"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
require("./version");
tslib_1.__exportStar(require("./components/Layer/index"), exports);
//# sourceMappingURL=Layer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/Layer.js
// module id = 617
// module chunks = 0